import { render, staticRenderFns } from "./CompanyLogo.vue?vue&type=template&id=6d4b713b&scoped=true&"
import script from "./CompanyLogo.vue?vue&type=script&lang=ts&"
export * from "./CompanyLogo.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyLogo.vue?vue&type=style&index=0&id=6d4b713b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4b713b",
  null
  
)

export default component.exports